var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPendingOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2445_1396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1641 1.02911V11.7187H58.8529L48.1641 1.02911Z",
    fill: "#EA9840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4062 15.2344C45.4355 15.2344 44.6484 14.4473 44.6484 13.4766V0H19.4531C16.5454 0 14.1797 2.36566 14.1797 5.27344V24.9245C14.7588 24.872 15.3449 24.8438 15.9375 24.8438C21.9291 24.8438 27.2926 27.5831 30.8421 31.875H49.9219C50.8927 31.875 51.6797 32.662 51.6797 33.6328C51.6797 34.6036 50.8927 35.3906 49.9219 35.3906H33.158C34.2567 37.5347 34.9652 39.91 35.1927 42.4219H49.9219C50.8927 42.4219 51.6797 43.2089 51.6797 44.1797C51.6797 45.1505 50.8927 45.9375 49.9219 45.9375H35.1927C34.667 51.7429 31.5653 56.8155 27.042 60H54.6094C57.5171 60 59.8828 57.6343 59.8828 54.7266V15.2344H46.4062ZM49.9219 24.8438H24.1406C23.1698 24.8438 22.3828 24.0567 22.3828 23.0859C22.3828 22.1152 23.1698 21.3281 24.1406 21.3281H49.9219C50.8927 21.3281 51.6797 22.1152 51.6797 23.0859C51.6797 24.0567 50.8927 24.8438 49.9219 24.8438Z",
    fill: "#EA9840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 28.3594C7.21418 28.3594 0.117188 35.4564 0.117188 44.1797C0.117188 52.903 7.21418 60 15.9375 60C24.6608 60 31.7578 52.903 31.7578 44.1797C31.7578 35.4564 24.6608 28.3594 15.9375 28.3594ZM20.625 45.9375H15.9375C14.9667 45.9375 14.1797 45.1505 14.1797 44.1797V37.1484C14.1797 36.1777 14.9667 35.3906 15.9375 35.3906C16.9083 35.3906 17.6953 36.1777 17.6953 37.1484V42.4219H20.625C21.5958 42.4219 22.3828 43.2089 22.3828 44.1797C22.3828 45.1505 21.5958 45.9375 20.625 45.9375Z",
    fill: "#EA9840"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2445_1396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPendingOrder);
export default __webpack_public_path__ + "static/media/iconPendingOrder.70a3b8f6a1d595c9678b36197d2529a2.svg";
export { ForwardRef as ReactComponent };